/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class FieldTitleFilter {
    public static filter(): any {
        return (input: string): string => {
            return input.replace(/_/g, ' ').
            replace(/\w\S*/g, (txt) => {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        };
    }
}


angular.module('beneple.global')
    .filter('fieldtitle', FieldTitleFilter.filter);



// WEBPACK FOOTER //
// ./frontend/scripts/global/filters/fieldtitle.filter.ts